import { HTMLarkdown } from 'htmlarkdown';
import { supRule } from './supRule';
import { tableRule } from './tableRule';
import { referenceRule } from './referenceRule';
import { citationRule } from './citationRule';
import { horizontalRule } from './horizontalRule';


export const convertHtmlToMarkdown = (htmlContents: string[]): string[] => {
  const htmlarkdown = new HTMLarkdown();

  htmlarkdown.addRule(tableRule);
  htmlarkdown.addRule(supRule);
  htmlarkdown.addRule(referenceRule);
  htmlarkdown.addRule(citationRule);
  htmlarkdown.addRule(horizontalRule);

  return htmlContents.map(htmlContent => htmlarkdown.convert(htmlContent, true));
};
